import { HttpClient } from '@angular/common/http';
import {
  forwardRef,
  Inject,
  Injectable,
  InjectionToken,
  Optional,
} from '@angular/core';
import { parseData } from '@ups/xplat/utils';
import { TableviewModel, TableviewShareModel } from '@ups/xplat/api/dto';
import { MyHttpClientFactory } from '../http/my-http-client-factory';
import { environment } from '../environments';
import { map } from 'rxjs';

const GET_TABLEVIEWS = '/api/tableviews/{:key}';
const SAVE_TABLEVIEW = '/api/tableview';
const SAVE_TABLEVIEW_SHARE = '/api/tableview/share';

/**
 * Base URL of the API that serves saved grid views (`/api/tableviews/{key}`, `/api/tableview`, `/api/tableview/share`).
 * Not provided by default, so views come from the Sparta API (`environment.urls.spartaAPI`). An app whose users sign in with a
 * token Sparta cannot validate provides another API that serves the same routes over the same data: web-hr-packet provides
 * `environment.urls.packetAPI` (Bug 35309).
 */
export const TABLEVIEW_API_URL = new InjectionToken<string>(
  'TABLEVIEW_API_URL'
);

@Injectable({ providedIn: 'root' })
export class TableviewService {
  http: HttpClient;

  constructor(
    @Inject(forwardRef(() => MyHttpClientFactory))
    private httpFactory: MyHttpClientFactory,
    @Optional() @Inject(TABLEVIEW_API_URL) apiUrl?: string | null
  ) {
    this.http = httpFactory.createHttpClient(
      apiUrl || environment.urls.spartaAPI
    );
  }

  public getTableviews(key: string) {
    const url = GET_TABLEVIEWS.split('{:key}').join(key);
    return this.http
      .get<TableviewModel[]>(url)
      .pipe(map((response) => parseData<TableviewModel[]>(response)));
  }

  public createTableView(view: TableviewModel) {
    return this.http
      .post<TableviewModel>(SAVE_TABLEVIEW, view)
      .pipe(map((response) => parseData<TableviewModel>(response)));
  }

  public updateTableView(view: TableviewModel) {
    return this.http
      .post<TableviewModel>(SAVE_TABLEVIEW, view)
      .pipe(map((response) => parseData<TableviewModel>(response)));
  }

  public saveTableViewShare(view: TableviewShareModel) {
    return this.http.post(SAVE_TABLEVIEW_SHARE, view).pipe(map(parseData));
  }
}
